export const createEntriesData = (
  currentTransactions,
  entryType,
  formData,
  categoriesArray,
  selectedStatement,
  companyId,
  vitaUserId
) => {
  const entriesData = [];
  const reconciliationPairs = [];

  for (let i = 0; i < currentTransactions.length; i++) {
    const txn = currentTransactions[i];
    const description =
      formData.individualDescriptions[txn.transactionHash] || formData.description.trim();

    if (entryType === 'transfer') {
      // CRIAR TRANSFERÊNCIA
      // Determinar conta de origem e destino baseado no tipo da transação
      const isIncome = txn.amount > 0;
      const sourceBankAccountId = isIncome
        ? formData.targetBankAccountId
        : selectedStatement.bankAccountId;
      const destinationBankAccountId = isIncome
        ? selectedStatement.bankAccountId
        : formData.targetBankAccountId;

      // Lançamento de saída (da conta de origem)
      const outgoingEntry = {
        companyId,
        userCreateId: vitaUserId,
        userUpdateId: vitaUserId,
        journalEntryType: 5, // Transferência
        isInput: false, // Saída
        dateCompetencia: new Date(txn.datePosted).toISOString().split('T')[0],
        dateVencimento: new Date(txn.datePosted).toISOString().split('T')[0],
        paymentType: 'TRANSFERENCIA',
        description: description,
        statusPayment: true,
        installmentsQuantity: null,
        fineValue: 0,
        interestValue: 0,
        discountValue: 0,
        value: Math.abs(txn.amount),
        categoryId: formData.categoryId || null, // Categoria é opcional para transferências
        bankAccountId: sourceBankAccountId,
        journalEntryRefId: null,
        fitId: null,
        reconciliationData: null,
      };

      // Lançamento de entrada (na conta de destino)
      // transferPairKey vincula este lançamento ao de saída correspondente: o backend
      // usa esse marcador para preencher journalEntryRefId após criar os dois registros
      // (sem isso, o par de transferência fica sem vínculo e a "Conta de Saída" some
      // ao reabrir o lançamento para edição depois de conciliado).
      const transferPairKey = `${txn.transactionHash}-${i}`;
      outgoingEntry.transferPairKey = transferPairKey;

      const incomingEntry = {
        companyId,
        userCreateId: vitaUserId,
        userUpdateId: vitaUserId,
        journalEntryType: 5, // Transferência
        isInput: true, // Entrada
        dateCompetencia: new Date(txn.datePosted).toISOString().split('T')[0],
        dateVencimento: new Date(txn.datePosted).toISOString().split('T')[0],
        paymentType: 'TRANSFERENCIA',
        description: description,
        statusPayment: true,
        installmentsQuantity: null,
        fineValue: 0,
        interestValue: 0,
        discountValue: 0,
        value: Math.abs(txn.amount),
        categoryId: formData.categoryId || null,
        bankAccountId: destinationBankAccountId,
        journalEntryRefId: null,
        transferPairKey,
        fitId: null,
        reconciliationData: null,
      };

      // Adicionar ambos os lançamentos
      // O lançamento que corresponde à transação do extrato deve ser adicionado primeiro
      if (isIncome) {
        // Se é entrada no extrato, o lançamento de entrada corresponde
        entriesData.push(incomingEntry);
        entriesData.push(outgoingEntry);

        // Apenas o lançamento de entrada será reconciliado com a transação do extrato
        reconciliationPairs.push({
          entryIndex: entriesData.length - 2, // Índice do lançamento de entrada
          transactionHash: txn.transactionHash,
          statementTransactionId: txn.id,
        });
      } else {
        // Se é saída no extrato, o lançamento de saída corresponde
        entriesData.push(outgoingEntry);
        entriesData.push(incomingEntry);

        // Apenas o lançamento de saída será reconciliado com a transação do extrato
        reconciliationPairs.push({
          entryIndex: entriesData.length - 2, // Índice do lançamento de saída
          transactionHash: txn.transactionHash,
          statementTransactionId: txn.id,
        });
      }
    } else {
      // CRIAR LANÇAMENTO REGULAR (ENTRADA OU SAÍDA)
      // Encontrar a categoria selecionada para determinar se é entrada ou saída
      const selectedCategory = categoriesArray.find((cat) => cat.id === formData.categoryId);

      // Preparar dados do lançamento
      const entryData = {
        companyId,
        userCreateId: vitaUserId,
        userUpdateId: vitaUserId,
        journalEntryType: 1, // Transação normal (não transferência)
        isInput: selectedCategory ? selectedCategory.isInput : txn.amount > 0, // Usar categoria ou fallback para valor da transação
        dateCompetencia: new Date(txn.datePosted).toISOString().split('T')[0],
        dateVencimento: new Date(txn.datePosted).toISOString().split('T')[0],
        paymentType: 'EXTRATO_BANCARIO',
        description: description,
        statusPayment: true, // Pago por padrão na conciliação
        installmentsQuantity: null,
        fineValue: 0,
        interestValue: 0,
        discountValue: 0,
        value: Math.abs(txn.amount), // Valor sempre positivo
        categoryId: formData.categoryId,
        bankAccountId: selectedStatement.bankAccountId,
        journalEntryRefId: null,
        fitId: null,
        reconciliationData: null,
      };

      entriesData.push(entryData);

      // Preparar par de conciliação
      // Cada transação regular cria exatamente 1 lançamento, portanto o índice é i
      reconciliationPairs.push({
        entryIndex: i,
        transactionHash: txn.transactionHash,
        statementTransactionId: txn.id,
      });
    }
  }

  return { entriesData, reconciliationPairs };
};
